<script setup>
  import { ref, computed, watchEffect } from 'vue';
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import { format, isToday, addDays, isFirstDayOfMonth } from 'date-fns';

  const props = defineProps({
    selectedDate: {
      type: Date,
      required: true
    },
    startDate: {
      type: Date,
      required: true
    },
    endDate: {
      type: Date,
      required: true
    }
  });  

  const emits = defineEmits(['update:selectedDate']);
  
  const isDesktop = useMediaQuery('(min-width: 840px)');

  const selectedWeekDate = ref(new Date(props.selectedDate));

  const weekDays = computed(() => {
    const days = [];
    let current = props.startDate;

    while (current < props.endDate) {
      days.push(current);
      current = addDays(current, 1);
    }

    return days;
  });

  function getDisplayDate(date) {
    date = new Date(date);
    
    if (isDesktop.value) return isFirstDayOfMonth(date) ? format(date, 'LLL, ccc d') : format(date, 'ccc d') ;

    return format(date, 'EEEEE d');
  }

  function handleSelectedDateUpdate(newDate) {
    selectedWeekDate.value = newDate;
    emits('update:selectedDate', newDate);
  }

  watchEffect(() => {
    selectedWeekDate.value = new Date(props.selectedDate);
  });
</script>

<template>
  <div class="jwx-graph-calendar__week">
    <slot name="graph"></slot>
    <div class="jwx-graph-calendar__days">
      <button
        class="jwx-graph-calendar__day"
        v-for="(day) in weekDays"
        @click.prevent="handleSelectedDateUpdate(day)"
        :key="day.getTime()"
        :data-is-today="isToday(day)"
        :data-is-month-start="isFirstDayOfMonth(day)"
        :data-is-selected="format(day, 'yyyy-MM-dd') === format(selectedWeekDate, 'yyyy-MM-dd')"
      >
        <p class="jwx-graph-calendar__date">{{ getDisplayDate(day) }}</p>
      </button>
    </div>
  </div>
</template>